import { render, staticRenderFns } from "./RouteEdit.vue?vue&type=template&id=b8f5c3d2&"
import script from "./RouteEdit.vue?vue&type=script&lang=js&"
export * from "./RouteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports